import React, { useState } from 'react';
import './RevisionScheduler.css'

export default function RevisionSchedulerButtonsAndTextBox({OnRevisionScheduleEvent, revisionSchedule})
{
    const initialOffset = revisionSchedule ?  revisionSchedule.PreviousOffset : 0;
    const [selectedOffset, setSelectedOffset] = useState(null);
    function OnButtonClick(offset)
    {
        setSelectedOffset(prevOffset => {
            var nextRevisionDate = new Date();
            if(prevOffset === offset)
            {
                // revert
                let revertdate = new Date(revisionSchedule.PreviousDateOfRevision);
                revertdate.setDate(revertdate.getDate() + initialOffset);
                OnRevisionScheduleEvent(revertdate, initialOffset, true);
                return null;
            }
            nextRevisionDate.setDate(new Date().getDate() + offset);
            OnRevisionScheduleEvent(nextRevisionDate, offset, false);
            return offset;
        })
    }
    function onCustomInput(Offset)
    {
        let offset = parseInt(Offset);
        if(isNaN(offset) || offset<=0)
            offset=0;
        // At least once a year you should see the topic
        if(offset>=365)
            offset=365
        var nextRevisionDate = new Date();
        nextRevisionDate.setDate(new Date().getDate() + offset)
        OnRevisionScheduleEvent(nextRevisionDate, offset);
        setSelectedOffset(null);
    }
    const buttonValues = [1, 3, 7, 14, 30, 60, 90];

    return (
        <div className="RevisionScheduler p-4">
          <label className="block mb-2 text-lg font-semibold">Schedule Revision in Days:</label>
          <div className="flex flex-wrap gap-2">
            {buttonValues.map((value, index) => (
              <button
                key={value}
                onClick={() => OnButtonClick(value)}
                className={`px-4 py-2 rounded-md text-[var(--textongreen)]] ${
                  // Gradient logic: transition from red to green across buttons
                  index === 0
                    ? 'bg-[#f47c7c]'  // Starting color (red-ish)
                    : index === 1
                    ? 'bg-[#e99d6d]'  // Intermediate (orange-ish)
                    : index === 2
                    ? 'bg-[#d6b965]'  // Intermediate (yellow-ish)
                    : index === 3
                    ? 'bg-[#b4c865]'  // Intermediate (lime-ish)
                    : index === 4
                    ? 'bg-[#87c168]'  // Intermediate (green-ish)
                    : 'bg-[#4cbf6a]'  // Ending color (green)
                } hover:brightness-110 transition-all ${
                  value === selectedOffset ? 'ring-2 ring-[var(--textmain1)]' : ''
                } ${value === initialOffset ? 'font-bold' : ''}`}
              >
                {value}
              </button>
            ))}
            <div className="">
              <input
                type="number"
                min="1"
                max="365"
                onChange={(e) => onCustomInput(e.target.value)}
                className="w-20 px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
              />
            </div>
          </div>
      
          {revisionSchedule && parseInt(revisionSchedule.RevisionCounter) > 1 && (
            <div className="mt-2 text-[20px] text-[var(--textmain1)]">
              ( Revised for {(parseInt(revisionSchedule.RevisionCounter) - 1).toString()} time(s) and last revised on {new Date(revisionSchedule.PreviousDateOfRevision).toLocaleDateString('en-GB')})
            </div>
          )}
          {revisionSchedule && revisionSchedule.NextRevisionDate && (
            <div className="mt-1 text-[20px] text-[var(--textmain1)]">
              ( Revision scheduled for {new Date(revisionSchedule.NextRevisionDate).toLocaleDateString('en-GB')})
            </div>
          )}
      
          <div className="gradLineAndLabel mt-4">
            <div className="h-2 rounded-full bg-gradient-to-r from-red-500 via-yellow-500 to-green-500"></div>
            <div className="gradlinelabels flex justify-between mt-1 text-xs">
              <div className="text-red-600">Beginner</div>
              <div className="text-green-600">Expert</div>
            </div>
          </div>
        </div>
      );

}